import { render, staticRenderFns } from "./DetailedRequestsSourceReport.vue?vue&type=template&id=6fd5a2bf&scoped=true&"
import script from "./DetailedRequestsSourceReport.vue?vue&type=script&lang=js&"
export * from "./DetailedRequestsSourceReport.vue?vue&type=script&lang=js&"
import style0 from "./DetailedRequestsSourceReport.vue?vue&type=style&index=0&id=6fd5a2bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd5a2bf",
  null
  
)

export default component.exports